<!--
 * @Author: your name
 * @Date: 2020-11-08 22:39:33
 * @LastEditTime: 2020-11-21 15:42:04
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/views/order/exchangesuccess/index.vue
-->
<template>
  <div class="ex_milk_order">
    <!-- 兑换鲜奶 -->
    <title-bar-back :title="'鲜奶卡兑换'" @back="back">
      <div class="title_right"></div>
    </title-bar-back>
    <div class="top">
      <img
        src="@/assets/order/icon_success_result@2x.png"
        alt=""
        class="succ_icon"
      />
      <span class="font22 font_weight500 line_height_30 succ_font"
        >兑换成功</span
      >
    </div>
    <div class="bottom_btn">
      <div
        class="item_btn font_weight400 font14 colo055 btn_mr line_height_30"
        @click="goDetail"
      >
        查看订单
      </div>
      <div
        class="item_btn font_weight400 font14 colo055 line_height_30"
        @click="goHome"
      >
        返回首页
      </div>
    </div>
  </div>
</template>
<script>
const TitleBarBack = () =>
  import("@/components/TitleBarBack").then(m => m.default || m);
export default {
  name: "ExchangeSuccess",
  components: {
    TitleBarBack
  },
  methods: {
    back() {
      this.$router.back();
    },
    goDetail() {
      this.$router.push({
        path: "/order/detail",
        query: {
          orderSn: this.$route.query.orderSn
        }
      });
    },
    goHome() {
      this.$router.push("/home");
    }
  }
};
</script>
<style lang="less" scoped>
.ex_milk_order {
  background: #fff;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  .title_right {
    width: 36px;
  }
  .top {
    padding: 24px 19px;
    .succ_font {
      color: #bf9264;
      vertical-align: middle;
      margin-left: 8px;
    }
    .succ_icon {
      vertical-align: middle;
      width: 40px;
    }
  }
  .bottom_btn {
    display: flex;
    justify-content: center;
  }
  .item_btn {
    padding: 0 18px;
    border-radius: 15px;
    border: 1px solid rgba(0, 0, 0, 0.38);
  }
  .btn_mr {
    margin-right: 20px;
  }
}
</style>
